(function (app, URL) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Test",
            {
                url: "/Test",
                component: "test"
            });
        }
    ]);

    app.component("test",
    {
        templateUrl: "/App/Test/Test.html",
        controller: testController
    });

    testController.$inject = [];

    function testController() {
        this.pick = function (id) {
            this.fileUrl = "http://localhost:58835/FakeFile/" + id;
        };
    }

    //app.directive("figAjaxIframeSrc", ["$http", function($http) {
    //    return {
    //        scope: { src: "<figAjaxIframeSrc" },
    //        link: function(scope, elem) {
    //            scope.$watch("src", updateIframe);
    //            var lastObjectUrl;

    //            scope.$on("$destroy", function() {
    //                if (lastObjectUrl)
    //                    URL.revokeObjectURL(lastObjectUrl);
    //            });

    //            function updateIframe(src) {
    //                if (!src) return;
    //                //can't just set elem[0].src = src, because we need to request the data through ajax so we can include our auth token
    //                //elem.src would not include auth tokens
    //                //TODO: wrap this in the apigateway with a method like GetFile or something and use that service instead of $http
    //                $http.get(src, { responseType: "blob" }).then(function (response) {
    //                    var url = URL.createObjectURL(response.data);
    //                    elem[0].src = url;
    //                    //need to make sure we eventually call URL.revokeObjectURL(url); once the viewer is closed!
    //                    if (lastObjectUrl)
    //                        URL.revokeObjectURL(lastObjectUrl);
    //                    lastObjectUrl = url;
    //                });
    //            }
    //        }
    //    };
    //}]);

})(window.app, window.URL);